import { render, staticRenderFns } from "./Spread.vue?vue&type=template&id=7b978472&scoped=true&"
import script from "./Spread.vue?vue&type=script&lang=js&"
export * from "./Spread.vue?vue&type=script&lang=js&"
import style0 from "./Spread.vue?vue&type=style&index=0&id=7b978472&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b978472",
  null
  
)

export default component.exports